import axios from "axios";
export const API_URL = "/api/v1";

export const GET_EMAIL_LIST = API_URL+"/alarm/get_email_list";
export const RE_SEND_EMAIL = API_URL+"/alarm/re_send_email/";
export const GET_SMS_LIST = API_URL+"/alarm/get_sms_list";
export const SEND_SMS = API_URL+"/alarm/send_sms/";
export const GET_SMS_TEMPLATE_LIST = API_URL+"/alarm/get_sms_template_list/";
export const GET_MY_COMPANY_LIST = API_URL+"/alarm/get_my_company_list/";
export const DELETE_SMS_TEMPLATE = API_URL+"/alarm/delete_sms_template/";
export const SAVE_SMS_TEMPLATE = API_URL+"/alarm/save_sms_template/";


export function getEmailList(params) {
  return axios.get(GET_EMAIL_LIST+ '?page='+ params.page + '&company_name=' + params.company_name + '&subject=' + params.subject + '&start_date=' + params.start_date + '&end_date=' + params.end_date );
}


export function reSendEmail(param) {
  return axios.post(RE_SEND_EMAIL, param);
}


export function getSmsList(params) {
  return axios.get(GET_SMS_LIST+ '?page='+ params.page + '&company_name=' + params.company_name + '&start_date=' + params.start_date + '&end_date=' + params.end_date );
}


export function sendSms(param) {
  return axios.post(SEND_SMS, param);
}

export function getSmsTemplateList(params) {
  return axios.get(GET_SMS_TEMPLATE_LIST+ '?page='+ params.page );
}

export function getMyCompanyList(params) {
  return axios.get(GET_MY_COMPANY_LIST+ '?company_name=' + params.company_name + '&company_number=' + params.company_number + '&collect_zone=' + params.collect_zone );
}

export function deleteSmsTemplate(params) {
  return axios.post(DELETE_SMS_TEMPLATE, params);
}

export function saveSmsTemplate(params) {
  return axios.post(SAVE_SMS_TEMPLATE, params);
}
